import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "hidden lg:fixed lg:inset-y-0 lg:z-50 lg:flex lg:w-72 lg:flex-col border-r border-gray-900/10 font-roboto" }
const _hoisted_2 = { class: "flex grow flex-col gap-y-4 overflow-y-auto px-6" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "flex h-16 shrink-0 items-center" }, [
  /*#__PURE__*/_createElementVNode("a", { href: "/landing" }, [
    /*#__PURE__*/_createElementVNode("img", {
      class: "h-8 w-auto",
      src: "/img/GetGo_Logo_Small.svg",
      alt: "GetGo Logo"
    })
  ])
], -1)
const _hoisted_4 = { class: "flex flex-1 flex-col" }
const _hoisted_5 = ["href"]
const _hoisted_6 = ["src"]
const _hoisted_7 = { class: "text-dark-blue font-bold" }
const _hoisted_8 = {
  key: 0,
  class: "ml-4"
}
const _hoisted_9 = ["href", "onClick"]
const _hoisted_10 = { class: "text-dark-blue font-medium ml-5" }
const _hoisted_11 = { class: "lg:pl-72" }
const _hoisted_12 = { class: "sticky top-0 z-40 flex h-16 shrink-0 items-center gap-x-4 border-b border-gray-200 bg-white px-4 shadow-sm sm:gap-x-6 sm:px-6 lg:px-8" }
const _hoisted_13 = { class: "flex flex-1 gap-x-4 justify-end lg:gap-x-6" }
const _hoisted_14 = { class: "relative flex flex-1 justify-center" }
const _hoisted_15 = { class: "text-2xl font-bold text-dark-blue" }
const _hoisted_16 = { class: "flex items-center gap-x-4 lg:gap-x-6" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("div", { class: "hidden lg:block lg:h-6 lg:w-px lg:bg-gray-900/10" }, null, -1)
const _hoisted_18 = {
  type: "button",
  class: "-m-1.5 flex items-center p-1.5",
  id: "user-menu-button",
  "aria-expanded": "false",
  "aria-haspopup": "true"
}
const _hoisted_19 = { class: "hidden lg:flex lg:items-center" }
const _hoisted_20 = { class: "mt-1 ml-1" }
const _hoisted_21 = { class: "text-dark-blue font-bold font-roboto text-sm" }
const _hoisted_22 = {
  key: 0,
  class: "text-gray-500 font-roboto text-xs text-left mt-1"
}
const _hoisted_23 = {
  key: 1,
  class: "text-gray-500 font-roboto text-xs text-left mt-1"
}
const _hoisted_24 = {
  key: 0,
  class: "absolute right-0 z-10 mt-2.5 w-48 px-2 origin-top-right rounded-md bg-white py-2 shadow-lg ring-1 ring-gray-900/5 focus:outline-none"
}
const _hoisted_25 = /*#__PURE__*/_createElementVNode("a", {
  href: "/profile",
  class: "flex items-center py-1.5 rounded hover:bg-hover-blue px-0.5 text-sm leading-6 text-dark-blue cursor-pointer"
}, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "mr-2",
    src: "/img/Icons/My_Profile.svg",
    alt: "My Profile"
  }),
  /*#__PURE__*/_createTextVNode(" My Profile ")
], -1)
const _hoisted_26 = /*#__PURE__*/_createElementVNode("img", {
  class: "mr-2",
  src: "/img/Icons/Log_Out.svg",
  alt: "Log Out"
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TaxCertificateModal = _resolveComponent("TaxCertificateModal")!
  const _component_FromToDateModal = _resolveComponent("FromToDateModal")!
  const _component_FileInputModal = _resolveComponent("FileInputModal")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createElementVNode("nav", _hoisted_4, [
          _createElementVNode("ul", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredNavigation, (item, index) => {
              return (_openBlock(), _createElementBlock("li", {
                key: index,
                class: "mb-3 group relative"
              }, [
                _createElementVNode("a", {
                  href: item.href,
                  class: _normalizeClass(["flex items-center py-1.5 rounded hover:bg-hover-blue", {'bg-hover-blue': _ctx.isActive(item.href)}])
                }, [
                  _createElementVNode("img", {
                    src: `/img/Icons/${item.icon}.svg`,
                    class: "h-5 mr-2",
                    alt: "Icon"
                  }, null, 8, _hoisted_6),
                  _createElementVNode("span", _hoisted_7, _toDisplayString(item.name), 1)
                ], 10, _hoisted_5),
                (item.submenu)
                  ? (_openBlock(), _createElementBlock("ul", _hoisted_8, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.submenu, (subItem, subIndex) => {
                        return (_openBlock(), _createElementBlock("li", {
                          key: subIndex,
                          class: "mb-2"
                        }, [
                          _createElementVNode("a", {
                            href: subItem.href,
                            class: _normalizeClass(["flex items-center py-1 rounded hover:bg-hover-blue", {'bg-hover-blue': _ctx.isActive(subItem.href)}]),
                            onClick: ($event: any) => (_ctx.handleSubItemClick(subItem))
                          }, [
                            _createElementVNode("span", _hoisted_10, _toDisplayString(subItem.name), 1)
                          ], 10, _hoisted_9)
                        ]))
                      }), 128))
                    ]))
                  : _createCommentVNode("", true)
              ]))
            }), 128))
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_11, [
      _createElementVNode("div", _hoisted_12, [
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("h1", _hoisted_15, _toDisplayString(_ctx.pageTitle), 1)
          ]),
          _createElementVNode("div", _hoisted_16, [
            _hoisted_17,
            _createElementVNode("div", {
              class: "relative",
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.toggleDropdown && _ctx.toggleDropdown(...args)))
            }, [
              _createElementVNode("button", _hoisted_18, [
                _createElementVNode("span", _hoisted_19, [
                  _createElementVNode("div", _hoisted_20, [
                    _createElementVNode("p", _hoisted_21, _toDisplayString(_ctx.userInfo ? _ctx.userInfo.given_name : '') + " " + _toDisplayString(_ctx.userInfo ? _ctx.userInfo.family_name: ''), 1),
                    (_ctx.userRoles.getgoAdmin)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_22, "GetGo Admin"))
                      : (_ctx.userRoles.schoolAdmin)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_23, "School Admin"))
                        : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("img", {
                    class: _normalizeClass(["ml-2 transition-transform", { 'rotate-180': _ctx.dropdownOpen }]),
                    src: "/img/Icons/Arrow_Down.svg",
                    alt: "Down Arrow"
                  }, null, 2)
                ])
              ]),
              (_ctx.dropdownOpen)
                ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                    _hoisted_25,
                    _createElementVNode("a", {
                      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.logout && _ctx.logout(...args))),
                      class: "flex items-center py-1.5 rounded hover:bg-hover-blue px-0.5 text-sm leading-6 text-dark-blue cursor-pointer"
                    }, [
                      _hoisted_26,
                      _createTextVNode(" Log Out ")
                    ])
                  ]))
                : _createCommentVNode("", true)
            ])
          ])
        ])
      ]),
      (_ctx.isTaxCertificateModalOpen)
        ? (_openBlock(), _createBlock(_component_TaxCertificateModal, {
            key: 0,
            "is-tax-certificate-modal-open": _ctx.isTaxCertificateModalOpen,
            onClose: _cache[2] || (_cache[2] = ($event: any) => (_ctx.isTaxCertificateModalOpen = false)),
            onContinue: _cache[3] || (_cache[3] = ($event: any) => (_ctx.handleTaxCertificate($event)))
          }, null, 8, ["is-tax-certificate-modal-open"]))
        : _createCommentVNode("", true),
      (_ctx.isDateModalOpen)
        ? (_openBlock(), _createBlock(_component_FromToDateModal, {
            key: 1,
            isDateModalOpen: _ctx.isDateModalOpen,
            reportRequestDto: _ctx.reportRequestDto,
            onDownload: _ctx.handleDownload,
            onClose: _cache[4] || (_cache[4] = ($event: any) => (_ctx.isDateModalOpen = false))
          }, null, 8, ["isDateModalOpen", "reportRequestDto", "onDownload"]))
        : _createCommentVNode("", true),
      (_ctx.isFileInputModalOpen)
        ? (_openBlock(), _createBlock(_component_FileInputModal, {
            key: 2,
            modelValue: _ctx.file,
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.file) = $event)),
            onClose: _cache[6] || (_cache[6] = ($event: any) => (_ctx.isFileInputModalOpen = false))
          }, null, 8, ["modelValue"]))
        : _createCommentVNode("", true)
    ])
  ]))
}